var _style, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTraining(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 99.6 99.6",
    style: {
      enableBackground: "new 0 0 99.6 99.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,38v-2c0-0.8,0.7-1.5,1.5-1.5l0,0h20.2v5H31.3C30.5,39.5,29.8,38.8,29.8,38z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.2,59.3H31.4c-0.9,0-1.6,0.7-1.6,1.6l0,0v1.7l0,0c0,0.9,0.7,1.6,1.6,1.6l0,0h30.5v4.3 c-1.6,0.5-2.5,2.1-2.1,3.7s2.1,2.5,3.7,2.1c1.6-0.5,2.5-2.1,2.1-3.7c-0.3-1-1.1-1.8-2.1-2.1v-4.3h4.7c0.9,0,1.6-0.7,1.6-1.6v-1.7 l0,0C69.8,60,69.1,59.3,68.2,59.3z M64.1,71.4c0,0.7-0.6,1.3-1.3,1.3s-1.3-0.6-1.3-1.3c0-0.7,0.6-1.3,1.3-1.3 C63.4,70.1,64,70.6,64.1,71.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M51.5,42.9v-1.8H32.4v16.5h34.8v-10h-2.3c-0.3,0-0.5,0.1-0.7,0.3l-3.4,3.7c-1.2,1.3-3.3,1.4-4.6,0.1 c-0.6-0.6-1-1.4-1-2.3v-1.9C53.1,47,51.5,45.1,51.5,42.9z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M72.6,30.8H56.2c-1.7,0-3,1.3-3,3V43c0.1,1.7,1.4,3,3.1,2.9c0.3,0,0.6,0.3,0.6,0.6v2.8c0,0.5,0.2,0.9,0.5,1.2 c0.6,0.6,1.6,0.5,2.2-0.1l3.4-3.7c0.5-0.5,1.2-0.8,1.9-0.8h7.7c1.7,0,3-1.3,3-3v-9.1C75.6,32.2,74.2,30.8,72.6,30.8z M62,41.4 c0,0.4-0.4,0.8-0.8,0.8h-0.1c-0.4,0-0.8-0.4-0.8-0.8v-6c0-0.4,0.3-0.8,0.8-0.8h0.1c0.4,0,0.8,0.4,0.8,0.8V41.4z M65.2,41.4 c0,0.4-0.4,0.8-0.8,0.8h-0.1c-0.4,0-0.8-0.4-0.8-0.8v-4.3c0-0.4,0.4-0.8,0.8-0.8h0.1c0.4,0,0.8,0.4,0.8,0.8V41.4z M68.4,41.4 c0,0.4-0.4,0.8-0.8,0.8h-0.1c-0.4,0-0.8-0.4-0.8-0.8v-6c0-0.4,0.4-0.8,0.8-0.8h0.1c0.4,0,0.8,0.4,0.8,0.8V41.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTraining);
export default __webpack_public_path__ + "static/media/training.6529343949dbb1b9e1d1157729b165f7.svg";
export { ForwardRef as ReactComponent };